'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = editedItems;

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EDIT_ITEM = 'EDIT_ITEM';

function editedItems() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case EDIT_ITEM:
      if (state[action.id]) {
        return state;
      }
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.id, true));
    default:
      return state;
  }
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/editedItems.js
 ** module id = 1119
 ** module chunks = 0
 **/